import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  index(params) {
    const url = apiRoutes.apiV1PublicBuyerLoanOfficersPath();

    return FetchHelpers.get(url, params);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/public/buyer/LoanOfficersRepository.js